import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';

function defaultErrorFn(props) {
  return /*#__PURE__*/React.createElement("span", {
    className: "qt-error"
  });
}
/**
 * This function can be used to generate a wrapper component that implements `componentDidCatch()`.
 *
 * Example
 * ```javascript
 * import { withError } from '@quintype/components';
 *
 * function errorFunction(props) {
 *   return <span />;
 * }
 *
 * const MyStoryElement = withError(ComponentThatMayCrash, errorFunction)
 *
 * <MyStoryElement/>
 * ```
 * @param {Component} clazz
 * @param {function} errorFn
 * @category Other
 * @returns {Component} A component with errors caught
 */


export function withError(clazz) {
  var errorFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultErrorFn;
  return /*#__PURE__*/function (_React$Component) {
    _inherits(WithError, _React$Component);

    var _super = _createSuper(WithError);

    function WithError(props) {
      var _this;

      _classCallCheck(this, WithError);

      _this = _super.call(this, props);
      _this.state = {
        errored: false
      };
      return _this;
    }

    _createClass(WithError, [{
      key: "componentDidCatch",
      value: function componentDidCatch(e) {
        console && e && console.log("Caught Exception: ".concat(e.message || e));
        this.setState({
          errored: true
        });
      }
    }, {
      key: "errorContent",
      value: function errorContent() {
        try {
          return errorFn(this.props);
        } catch (e) {
          return defaultErrorFn(this.props);
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (this.state.errored) {
          return this.errorContent();
        } else {
          return /*#__PURE__*/React.createElement(clazz, this.props);
        }
      }
    }]);

    return WithError;
  }(React.Component);
}